// import React from 'react';
// import { Button, Card, Col, Row } from 'antd';
// import { formatNumberWithSpaces } from '../utils/formatters';

// const PropertyCard = ({ property, deleteListing, editListing }: any) => {
//   const { location, title, description, price, propertyType, rooms, bathrooms, area, photos, availability, listedDate, _id, owner } = property;

//   const firstPhoto = photos && Array.isArray(photos) && photos[0] ? photos[0] : "";

//   return (
//     <Card
//       title={title}
//       extra={<span>{formatNumberWithSpaces(price)} eur</span>}
//     >
//       <Row gutter={8}>
//         {
//           // @ts-ignore
//           [firstPhoto].map((photo, index) => {
//             if (index === 0) {
//               return <Col key={index} span={6}>
//                 <img src={photo} alt={`${index + 1}`} style={{ width: '15rem', height: 'auto', border: '5px solid gold', borderRadius: 5 }} />
//               </Col>
//             }
//             return <Col key={index} span={6}>
//               <img src={photo} alt={`${index + 1}`} style={{ width: '15rem', height: 'auto', borderRadius: 5 }} />
//             </Col>
//           })}
//       </Row>
//       <pre style={{overflow: 'auto', whiteSpace: 'pre-wrap' }}>{description}</pre>
//       <p>Lokalita: {location?.city}</p>
//       <p>Adresa: {location?.address}</p>
//       <p>Typ nehnuteľnosti: {propertyType}</p>
//       <p>Izby: {rooms}</p>
//       <p>Kúpeľne: {bathrooms}</p>
//       <p>Plocha: {area} m²</p>
//       <p>Dostupnosť: {availability}</p>
//       <p>Dátum uvedenia na trh: {listedDate}</p>
//       <p>Majiteľ: {owner?.name}, {owner?.phone}, {owner?.address}</p>
//       <Button type="primary" style={{ marginTop: '1rem', backgroundColor: "red" }} onClick={() => deleteListing(_id)}>Vymazať</Button>
//       <Button type="primary" style={{ marginTop: '1rem', marginLeft: '1rem', backgroundColor: "green" }} onClick={() => editListing(_id)}>Upraviť</Button>
//     </Card>
//   );
// };

import { FC, useState } from "react";
import { Grid, Skeleton } from "@mui/material";

import Chip from "@mui/material/Chip";
// export default PropertyCard;
// components/PropertyCard.tsx
import { MapPinIcon } from "lucide-react";
import { formatPrice } from "../pages/helpers";

type Property = {
  _id: string;
  title: string;
  location: {
    city: string;
    address: string;
  };
  propertyType: string;
  wholeArea: number;
  price: number;
  photos: string[];
  tags?: string[];
};

const translatePropertyType = (propertyType: string) => {
  switch (propertyType) {
    case "house":
      return "Dom";
    case "apartment":
      return "Byt";
    case "building":
      return "Budova";
    case "land":
      return "Pozemok";
    case "hotel":
      return "Hotel";
    case "commercial":
      return "Obchodná nehnuteľnosť";
    case "garage":
      return "Garáž";
    case "room":
      return "Izba";
    case "cottage":
      return "Chata";
    case "farm":
      return "Farma";
    case "other":
      return "Iná nehnuteľnosť";
    case "country_house":
      return "Dom";
    case "family_house":
      return "Rodinný dom";
    default:
      return propertyType;
  }
};

const PropertyCard: FC<{ property: Property }> = ({ property }) => {
  if (!property.tags) {
    property.tags = [
      translatePropertyType(property.propertyType),
      `${property.wholeArea} m²`,
    ];
  }

  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <a href={`/properties/${property._id}`}>
      <Grid
        size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
        style={{
          minWidth: "250px",
          backgroundColor: "white",
          borderRadius: "1rem",
          padding: "1rem",
        }}
      >
        {!imageLoaded && (
          <Skeleton
            variant="rectangular"
            width="100%"
            height={200}
            style={{ borderRadius: "1rem" }}
          />
        )}
        <img
          src={property.photos[0]}
          alt={property.title}
          onLoad={() => setImageLoaded(true)}
          onError={() => setImageLoaded(true)} // hide skeleton on error too
          style={{
            display: imageLoaded ? "block" : "none",
            width: "100%",
            height: "200px",
            objectFit: "cover",
            borderRadius: "1rem",
          }}
        />

        <div className="mt-2 text-sm">
          <h3 className="font-medium ">{property.title.toUpperCase()}</h3>

          <div
            className="flex items-center mt-1 gap-1 align-baseline"
            style={{ color: "#9b8b4b" }}
          >
            <MapPinIcon
              style={{ fill: "#fff", width: "1rem", height: "1rem" }}
            />
            <span className="text-sm">{property.location.city}</span>
          </div>
          <div
            className="flex mt-2 space-x-1 text-xs"
            style={{ marginTop: "1rem" }}
          >
            {property.tags?.map((tag) => (
              <Chip
                key={tag}
                className="border px-2 py-1 rounded-full"
                label={tag}
                style={{ marginRight: "0.5rem" }}
                onClick={() => console.log("tag", tag)}
              />
            ))}
          </div>
          <div
            className="font-bold mt-2 text-black"
            style={{
              color: "#9b8b4b",
              fontSize: "1.5rem",
              fontWeight: "bold",
              marginTop: "1rem",
            }}
          >
            {formatPrice(property?.price)}
          </div>
        </div>
      </Grid>
    </a>
  );
};

export default PropertyCard;
